import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { asNumberOrDefault, titleCase } from '~/lib/helper/StringHelper';
import { range } from '~/lib/helper/ArrayHelper';
import ErrorList from '../ErrorList';

type BackupOptionSelectProps = {
    type: string;
    duration: string;
    cost_per_backup: number;
    included: number;
    value: number;
    error: string[];
    onChange: (v: number) => unknown;
};

export default class BackupOptionSelect extends React.Component<BackupOptionSelectProps> {
    render() {
        const { type, duration, cost_per_backup, included, value, error, onChange } = this.props;

        return (
            <FormGroup>
                <Label for={'backupSelection' + type}>{titleCase(type)} backups</Label>
                <Input
                    type="select"
                    id={'backupSelection' + type}
                    value={value}
                    invalid={error.length > 0}
                    className="maxw-500"
                    onChange={(e) => onChange(asNumberOrDefault(e.target.value, 0))}
                >
                    <option value={0}>Do not take a {type} backup</option>
                    <option value={1}>
                        Take {type} backups, stored for 1 {duration}{' '}
                        {included < 1 ? `(+$${cost_per_backup.toFixed(2)} per month)` : '(included)'}
                    </option>
                    {range(2, 10).map((i) => (
                        <option key={i} value={i}>
                            Take {type} backups, stored for {i} {duration}s{' '}
                            {i - included > 0
                                ? `(+$${((i - included) * cost_per_backup).toFixed(2)} per month)`
                                : '(included)'}
                        </option>
                    ))}
                </Input>
                <FormFeedback>
                    <ErrorList errors={error} />
                </FormFeedback>
            </FormGroup>
        );
    }
}
